export default "__VITE_ASSET__a40dc128__"